/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  const sliders = document.querySelectorAll('.text-slider');
  if(sliders) {
    Array.prototype.forEach.call(sliders, function(slider) {
      const slider_container = slider.querySelector('.text-slider-container');
      const slider_track = slider.querySelector('.text-slider-track');
      const slides = slider.querySelectorAll('.text-slider-slide');
      const paging_prev = slider.querySelector('.page-prev');
      const paging_next = slider.querySelector('.page-next');
      var slide_width = slider.offsetWidth - paging_prev.offsetWidth - paging_next.offsetWidth;
      var current_index = 0;

      if(slide_width <= 0) {
        slide_width = slider.offsetWidth - 30;
      }

      draw_slides(slider, slider_container, slider_track, slides, paging_prev, paging_next, slide_width, current_index);

      window.addEventListener('resize', function() {
        slide_width = slider.offsetWidth - paging_prev.offsetWidth - paging_next.offsetWidth;

        if(slide_width <= 0) {
          slide_width = slider.offsetWidth - 30;
        }

        draw_slides(slider, slider_container, slider_track, slides, paging_prev, paging_next, slide_width, current_index);
      });

      paging_prev.querySelector('a').addEventListener('click', function(e) {
        e.preventDefault();

        if(!this.classList.contains('disabled') && current_index > 0) {
          current_index = current_index - 1;

          slider_track.style.left = ((slide_width * current_index) * -1) + 'px';

          // Set height based on slide height, plus room for button
          slider_container.style.height = (slides[current_index].offsetHeight + 30) + 'px';

          if(current_index === 0) {
            paging_prev.classList.add('disabled');
            paging_next.classList.remove('disabled');
          } else {
            paging_prev.classList.remove('disabled');
            paging_next.classList.remove('disabled');
          }
        }
      });

      paging_next.querySelector('a').addEventListener('click', function(e) {
        e.preventDefault();

        if(!this.classList.contains('disabled') && (current_index + 1) < slides.length) {
          current_index = current_index + 1;

          slider_track.style.left = ((slide_width * current_index) * -1) + 'px';

          // Set height based on slide height, plus room for button
          slider_container.style.height = (slides[current_index].offsetHeight + 30) + 'px';

          if(current_index === (slides.length - 1)) {
            paging_prev.classList.remove('disabled');
            paging_next.classList.add('disabled');
          } else {
            paging_prev.classList.remove('disabled');
            paging_next.classList.remove('disabled');
          }
        }
      });
    });
  }

  function draw_slides(slider, slider_container, slider_track, slides, paging_prev, paging_next, slide_width, current_index) {
    var offset = 0;

    slider_track.style.width = (slide_width * slides.length) + 'px';

    Array.prototype.forEach.call(slides, function(slide) {
      slide.style.width = slide_width + 'px';
      slide.style.left = offset + 'px';

      offset = offset + slide_width;
    });

    slider_track.style.left = ((slide_width * current_index) * -1) + 'px';

    // Set height based on slide height, plus room for button
    slider_container.style.height = (slides[current_index].offsetHeight + 30) + 'px';
  }
}());
